export const CREATE_ADMIN_REQUEST_STAFF_TRANSFER = "CREATE_ADMIN_REQUEST_STAFF_TRANSFER";
export const FULL_TRANSFER_REQUEST_STAFF_TRANSFER = "FULL_TRANSFER_REQUEST_STAFF_TRANSFER";
export const INFO_TRANSFER_REQUEST_STAFF_TRANSFER = "INFO_TRANSFER_REQUEST_STAFF_TRANSFER";
export const DENY_TRANSFER_REQUEST_STAFF_TRANSFER = "DENY_TRANSFER_REQUEST_STAFF_TRANSFER";
export const DELETE_TRANSFER_REQUEST_STAFF_TRANSFER = "DELETE_TRANSFER_REQUEST_STAFF_TRANSFER";
export const RETRIEVE_ADMIN_REQUEST_STAFF_TRANSFER = "RETRIEVE_ADMIN_REQUEST_STAFF_TRANSFER";
export const RETRIEVESINGLE_ADMIN_REQUEST_STAFF_TRANSFER = "RETRIEVESINGLE_ADMIN_REQUEST_STAFF_TRANSFER";
export const UPDATE_ADMIN_REQUEST_STAFF_TRANSFER = "UPDATE_ADMIN_REQUEST_STAFF_TRANSFER";
export const DELETE_ADMIN_REQUEST_STAFF_TRANSFER = "DELETE_ADMIN_REQUEST_STAFF_TRANSFER";
